(() => {
  if (window.homedockPdpRefinementInitialized) return;
  window.homedockPdpRefinementInitialized = true;
  function initialize(root = document) {
    root.querySelectorAll('.product-detail-refined').forEach((product) => {
      if (product.dataset.refinementReady) return;
      product.dataset.refinementReady = 'true';
      const gallery = product.querySelector('media-gallery');
      const viewer = gallery?.querySelector('.main-gallery');
      const slides = Array.from(viewer?.querySelectorAll('.product__media-item[data-media-id]') || []);
      if (slides.length > 1) {
        const indicators = document.createElement('div');
        indicators.className = 'pdp-media-dots';
        indicators.setAttribute('role', 'group');
        indicators.setAttribute('aria-label', 'Escolher imagem do produto');
        const buttons = slides.map((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pdp-media-dot';
          dot.setAttribute('aria-label', `Mostrar imagem ${index + 1} de ${slides.length}`);
          dot.setAttribute('aria-controls', slide.id);
          dot.addEventListener('click', () => gallery.setActiveMedia(slide.dataset.mediaId, false));
          indicators.append(dot);
          return dot;
        });
        const updateDots = (active) => {
          const activeIndex = Math.max(0, slides.indexOf(active));
          const firstVisible = Math.min(Math.max(0, activeIndex - 2), Math.max(0, slides.length - 5));
          buttons.forEach((dot, index) => {
            if (slides[index] === active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
            dot.hidden = index < firstVisible || index >= firstVisible + 5;
          });
        };
        updateDots(slides.find(slide => slide.classList.contains('is-active')) || slides[0]);
        viewer.addEventListener('slideChanged', event => {
          if (event.detail.currentElement) updateDots(event.detail.currentElement);
        });
        viewer.append(indicators);
      }
      const list = gallery?.querySelector('[id^="Slider-Thumbnails"]');
      if (list) {
        const mediaIds = new Set(Array.from(gallery.querySelectorAll('.main-gallery [data-media-id]'), item => item.dataset.mediaId));
        const items = Array.from(list.querySelectorAll('[data-target]')).filter(item => mediaIds.has(item.dataset.target));
        list.querySelectorAll('[data-target]').forEach(item => { if (!mediaIds.has(item.dataset.target)) item.hidden = true; });
        items.forEach((item, index) => { item.hidden = index >= 5; });
        if (items.length > 5) {
          const more = document.createElement('button');
          more.type = 'button';
          more.className = 'pdp-more-images';
          more.textContent = `+${items.length - 5}`;
          more.setAttribute('aria-label', `Mostrar mais ${items.length - 5} imagens`);
          more.setAttribute('aria-expanded', 'false');
          more.setAttribute('aria-controls', list.id);
          list.parentElement.append(more);
          more.addEventListener('click', () => {
            const expanded = more.getAttribute('aria-expanded') !== 'true';
            items.forEach((item, index) => { item.hidden = !expanded && index >= 5; });
            more.setAttribute('aria-expanded', String(expanded));
            more.setAttribute('aria-label', expanded ? 'Mostrar menos imagens' : `Mostrar mais ${items.length - 5} imagens`);
            more.textContent = expanded ? 'Ver menos' : `+${items.length - 5}`;
          });
        }
        gallery.querySelectorAll('.main-gallery .slider-button').forEach(original => {
          const button = original.cloneNode(true);
          original.replaceWith(button);
          button.disabled = items.length < 2;
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopImmediatePropagation();
            const current = items.findIndex(item => item.dataset.target === gallery.querySelector('.main-gallery .is-active')?.dataset.mediaId);
            const next = (current + (button.name === 'next' ? 1 : -1) + items.length) % items.length;
            if (items[next]) gallery.setActiveMedia(items[next].dataset.target, false);
          }, true);
        });
      }
      product.querySelectorAll('tab-component.tab__blocks').forEach(tabs => {
        const accordion = document.createElement('div');
        accordion.className = 'pdp-accordion';
        tabs.querySelectorAll('.nav-tabs .tablinks').forEach((tab, index) => {
          const panel = tabs.querySelector(`[id="${tab.id.replace('#', '')}"]`);
          if (!panel) return;
          const details = document.createElement('div');
          details.className = 'pdp-detail-panel';
          details.id = `${product.id}-panel-${index}`;
          details.hidden = index !== 0;
          const summary = document.createElement('button');
          summary.type = 'button';
          summary.className = 'pdp-detail-heading';
          summary.setAttribute('aria-controls', details.id);
          summary.setAttribute('aria-expanded', String(index === 0));
          summary.addEventListener('click', () => {
            const open = summary.getAttribute('aria-expanded') !== 'true';
            accordion.querySelectorAll('.pdp-detail-heading').forEach(heading => heading.setAttribute('aria-expanded', 'false'));
            accordion.querySelectorAll('.pdp-detail-panel').forEach(item => { item.hidden = true; });
            summary.setAttribute('aria-expanded', String(open));
            details.hidden = !open;
          });
          summary.textContent = tab.textContent;
          const content = document.createElement('div');
          content.className = 'pdp-description is-collapsed';
          content.id = `${product.id}-detail-${index}`;
          const existing = panel.querySelector('.pdp-description');
          const source = existing || panel;
          while (source.firstChild) content.append(source.firstChild);
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'pdp-description-toggle';
          toggle.textContent = 'Ver mais';
          toggle.setAttribute('aria-controls', content.id);
          toggle.setAttribute('aria-expanded', 'false');
          details.append(content, toggle);
          accordion.append(summary, details);
        });
        tabs.replaceWith(accordion);
      });
      const note = gallery?.querySelector('.pdp-image-note');
      const info = product.querySelector('.product__info-container');
      if (note && info) {
        const mobileNote = note.cloneNode(true);
        mobileNote.classList.add('pdp-image-note--mobile');
        note.classList.add('pdp-image-note--desktop');
        info.append(mobileNote);
      }
      product.querySelectorAll('.pdp-description-toggle').forEach(button => {
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          document.getElementById(button.getAttribute('aria-controls'))?.classList.toggle('is-collapsed', !expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'Ver menos' : 'Ver mais';
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('product-info:loaded', event => {
    queueMicrotask(() => initialize(event.target.parentElement || document));
  });
})();
